var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 4.08337H2.33366C1.68933 4.08337 1.16699 4.60571 1.16699 5.25004V11.0834C1.16699 11.7277 1.68933 12.25 2.33366 12.25H11.667C12.3113 12.25 12.8337 11.7277 12.8337 11.0834V5.25004C12.8337 4.60571 12.3113 4.08337 11.667 4.08337Z",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 12.25V2.91667C9.33366 2.60725 9.21074 2.3105 8.99195 2.09171C8.77316 1.87292 8.47641 1.75 8.16699 1.75H5.83366C5.52424 1.75 5.22749 1.87292 5.0087 2.09171C4.78991 2.3105 4.66699 2.60725 4.66699 2.91667V12.25",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishers);
export default __webpack_public_path__ + "static/media/publishers.907a0a8912af416678a1c40f9345a76d.svg";
export { ForwardRef as ReactComponent };